import { colors } from '../../colors';
var staff = {
  bgPrimaryColor: colors.paleGrey,
  bgSecondaryColor: colors.white,
  bgColorBio: colors.white,
  breadcrumbColor: colors.dirtyBlue,
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.black,
  iconHoverColor: colors.dirtyBlue,
  iconBorderColor: colors.black,
  iconBorderHoverColor: colors.dirtyBlue,
  bladeSubHeadingColor: colors.dirtyBlue,
  fiveBladeLinkColor: colors.dirtyBlue,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default staff;